import {
	Button,
	Col,
	ColorPicker,
	Flex,
	Form,
	Input,
	Row,
	notification,
} from "antd";
import React, { useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { RollbackOutlined } from "@ant-design/icons";

const NewStrategy = ({ history }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const createStrategy = async (data) => {
		setLoading(true);

		const strategy = {
			name: data.name,
			description: data.description,
			color: data.color,
		};

		try {
			const url = api + "/strategy/create";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, strategy);
			if (data.success) {
				openNotification("success", "Success", "Strategy created");
				setTimeout(() => {
					setLoading(false);
					history.push("/strategy/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to create strategy",
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		createStrategy(values);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Description" name="description">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Color"
							name="color"
							rules={[
								{
									required: true,
									message: "Please select a color",
								},
							]}
							getValueFromEvent={(color) => color?.toHexString()}
						>
							<ColorPicker format="hex" showText />
						</Form.Item>
					</Col>
				</Row>

				<Button type="primary" htmlType="submit" loading={loading} size="large">
					Create
				</Button>
			</Form>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout
			title="New Strategy"
			description="Create new Strategy"
			type="medium"
		>
			<Flex gap={"middle"} vertical>
				<Button
					type="primary"
					icon={<RollbackOutlined />}
					onClick={goBack}
					size="large"
				/>
				<CustomForm />
			</Flex>
			{contextHolder}
		</Layout>
	);
};

export default NewStrategy;
